<template>
  <div class="warningList">
    <div v-if="WarningData.length > 0">
      <Warningcomponents :WarningProp="WarningData" @WarnInfo="WarnInfo"></Warningcomponents>
    </div>
    <div v-else>
      <img src="@/assets/DefaultPage/Warning.png" alt="" width="640px" height="480px" style="margin-left: 250px;">
    </div>
    <div class="pagination" v-show="WarningData.length > 0">
      <Pagination type="allColor" layout="total, prev, pager, next, jumper" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total" :pageSize="pageSize"></Pagination>
    </div>
    <DialogFrom width="800px" title="查看详情" :dialogVisible="dialogVisibWarnInfo" @cancel="cancelWarnInfo" @dialogOK="dialogOKWarnInfo">
      <!-- RejectLicense证照驳回提醒 -->
      <div class="WarnInfoCss">
        <div v-if="WarnInfoList.Type == 'RejectLicense'" class="">
          <Reject :WarnInfoList="WarnInfoList" :WarnInfoData="WarnInfoData"></Reject>
        </div>
        <!-- WarningValiDate 近效期预警 -->
        <div v-if="WarnInfoList.Type == 'WarningValiDate'">
          <Effective :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></Effective>
        </div>
        <!-- AddLicense证照上传提醒 -->
        <div v-if="WarnInfoList.Type == 'AddLicense'">
          <div v-if="WarnInfoList.VoucherType == '营业执照'">
            <BusinessLicenseUpload :WarnInfoData="WarnInfoData"></BusinessLicenseUpload>
          </div>
          <div v-if="WarnInfoList.VoucherType == '医疗器械经营许可证'">
            <MedicalLicenseUpload :WarnInfoData="WarnInfoData"></MedicalLicenseUpload>
          </div>
          <div v-if="WarnInfoList.VoucherType == '第二类医疗器械备案凭证'">
            <MedicalDeviceLicenseUpload :WarnInfoData="WarnInfoData"></MedicalDeviceLicenseUpload>
          </div>
        </div>
        <!-- LicenseWarning证照过期预警 -->
        <div v-if="WarnInfoList.Type == 'LicenseWarning'">
          <div v-if="WarnInfoList.VoucherType == '营业执照'">
            <OverdueBusiness :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></OverdueBusiness>
          </div>
          <div v-if="WarnInfoList.VoucherType == '医疗器械经营许可证'">
            <OverdueMedical :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></OverdueMedical>
          </div>
          <div v-if="type == '第二类医疗器械备案凭证'">
            <OverdueMedicalDevice :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></OverdueMedicalDevice>
          </div>
        </div>
        <!-- WarningPrice发票底价预警 -->
        <div v-if="WarnInfoList.Type == 'WarningPrice'">
          <LowPriceWarning :WarnInfoData="WarnInfoData"></LowPriceWarning>
        </div>
        <!-- SaleBillCheckLabel  1、发票未通过校验。 2、发票驳回 3、发票待处理-->
        <div v-if="WarnInfoList.Type == 'SaleBillCheckLabel'">
          <Invoice :WarnInfoData="WarnInfoList"></Invoice>
        </div>
      </div>
    </DialogFrom>
  </div>
</template>

<script>
import Warningcomponents from '../../HomePage/components/warningCenterComponents/warning/components/warningList.vue'
import Pagination from '../../../../../components/pagination.vue'
import DialogFrom from '../../../../../components/dialog-from.vue'
import CommonuploadEnclosure from '../../../../../components/common-upload-Enclosure.vue'
import Reject from './components/reject'
import Effective from './components/effective'
import BusinessLicenseUpload from './components/BusinessLicenseUpload'
import MedicalLicenseUpload from './components/MedicalLicenseUpload'
import MedicalDeviceLicenseUpload from './components/MedicalDeviceLicenseUpload'
import OverdueBusiness from './components/OverdueBusiness'
import OverdueMedical from './components/OverdueMedical'
import OverdueMedicalDevice from './components/OverdueMedicalDevice'
import LowPriceWarning from './components/LowPriceWarning'
import Invoice from './components/invoice'
import {
  HomeRemindGetWainingDetail
} from '@/api/channel'
export default {
  components: {
    Warningcomponents,
    Pagination,
    DialogFrom,
    CommonuploadEnclosure,
    Reject,
    Effective,
    BusinessLicenseUpload,
    MedicalLicenseUpload,
    MedicalDeviceLicenseUpload,
    OverdueBusiness,
    OverdueMedical,
    OverdueMedicalDevice,
    LowPriceWarning,
    Invoice
  },
  props: {
    WarningData: {
      type: Array
    },
    total: {
      type: Number,
    },
    pageSize: {
      type: Number,
    },
  },
  data() {
    return {
      dialogVisibWarnInfo: false,
      type: '驳回',
      WarnInfoList: {},
      WarnInfoData: undefined,
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    async HomeRemindGetWainingDetail(id) {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message
      } = await HomeRemindGetWainingDetail({
        id: id
      })
      if (code == 0) {
        if (data) {
          this.dialogVisibWarnInfo = true
          this.WarnInfoData = data
        }
      } else {
        // this.$message.warning(message)
      }
      loading.close()
    },
    WarnInfo(item) {
      this.WarnInfoList = item
      this.HomeRemindGetWainingDetail(item.ID)
    },

    handleSizeChange(PageSize) {
      this.$emit("handleSizeChange", PageSize)
    },
    handleCurrentChange(PageIndex) {
      this.$emit("handleCurrentChange", PageIndex)
    },
    cancelWarnInfo() {
      this.dialogVisibWarnInfo = false
    },
    dialogOKWarnInfo() {
      this.dialogVisibWarnInfo = false
    },

  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(./style/index.less);

.WarnInfoCss {
  max-height: 550px;
  overflow-y: scroll;
}
</style>